export const communityData = [
  {
    title: "Global Web3 Communities",
    content: [
      {
        type: "heading",
        text: "Building the Decentralized Future Together"
      },
      {
        type: "paragraph",
        text: "Web3 communities are the driving force behind the decentralized revolution. These groups of developers, enthusiasts, and innovators work together to promote adoption, education, and development of Web3 technologies worldwide."
      },
      {
        type: "paragraph",
        text: "Key global Web3 communities include:"
      },
      {
        type: "list",
        items: [
          "Superteam: Global community with local teams in various countries",
          "Ethereum Foundation: Supporting Ethereum ecosystem development",
          "Gitcoin: Funding open-source Web3 projects",
          "Developer DAO: Community of Web3 developers and builders",
          "Bankless DAO: Media and education-focused community"
        ]
      }
    ]
  },
  {
    title: "Superteam Network",
    content: [
      {
        type: "heading",
        text: "Local Teams, Global Impact"
      },
      {
        type: "paragraph",
        text: "Superteam is a unique Web3 community model with local teams operating in various countries around the world. Each local team focuses on building and promoting Web3 adoption in their region while being part of a global network."
      },
      {
        type: "paragraph",
        text: "Superteam locations include:"
      },
      {
        type: "list",
        items: [
          "Superteam India: Largest and most active chapter",
          "Superteam Turkey: Growing Web3 ecosystem in Turkey",
          "Superteam Germany: European Web3 hub",
          "Superteam Vietnam: Southeast Asian expansion",
          "Superteam Mexico: Latin American presence",
          "Superteam Nigeria: African Web3 development"
        ]
      }
    ]
  },
  {
    title: "Regional Web3 Communities",
    content: [
      {
        type: "heading",
        text: "Asia-Pacific Region"
      },
      {
        type: "paragraph",
        text: "The Asia-Pacific region has emerged as a major hub for Web3 innovation and adoption:"
      },
      {
        type: "list",
        items: [
          "Singapore: Regulatory-friendly environment and major exchanges",
          "South Korea: Gaming and NFT innovations",
          "Japan: Early crypto adoption and regulatory clarity",
          "Australia: Growing DeFi and blockchain development",
          "Thailand: Government blockchain initiatives"
        ]
      }
    ]
  },
  {
    title: "Types of Web3 Communities",
    content: [
      {
        type: "heading",
        text: "Different Community Focus Areas"
      },
      {
        type: "paragraph",
        text: "Web3 communities organize around various interests and specializations:"
      },
      {
        type: "list",
        items: [
          "Developer Communities: Technical builders and programmers",
          "DAO Communities: Decentralized governance and collaboration",
          "Gaming Communities: Play-to-earn and NFT gaming",
          "Artist Communities: NFT creators and digital artists",
          "Investment Communities: DeFi and crypto trading groups",
          "Education Communities: Learning and teaching Web3 concepts"
        ]
      }
    ]
  },
  {
    title: "Benefits of Community Participation",
    content: [
      {
        type: "heading",
        text: "Why Join Web3 Communities?"
      },
      {
        type: "paragraph",
        text: "Participating in Web3 communities offers numerous benefits:"
      },
      {
        type: "list",
        items: [
          "Learning Opportunities: Access to cutting-edge knowledge and tutorials",
          "Networking: Connect with like-minded individuals and industry experts",
          "Career Development: Job opportunities and skill development",
          "Project Collaboration: Work on innovative Web3 projects",
          "Early Access: Get early information about new projects and opportunities",
          "Mentorship: Learn from experienced community members"
        ]
      }
    ]
  },
  {
    title: "How to Get Involved",
    content: [
      {
        type: "heading",
        text: "Starting Your Web3 Community Journey"
      },
      {
        type: "paragraph",
        text: "Getting involved in Web3 communities is easier than ever:"
      },
      {
        type: "list",
        items: [
          "Join Discord servers and Telegram groups",
          "Attend virtual and in-person meetups",
          "Participate in hackathons and building competitions",
          "Contribute to open-source projects",
          "Share knowledge through blogs and tutorials",
          "Start local Web3 meetups in your area"
        ]
      }
    ]
  }
];
